import { ClickListener } from '../../../../../lib/web/components/click-listener';
import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { CardNavigationService } from '../../../services/card-navigation.service';
import { DataEventService } from '../../../services/data-event.service';

@Component({
    selector: '.o-featured'
})
export class FeaturedComponent extends ComponentBase<HTMLElement> {

    public constructor(node: HTMLElement, 
        private _cardNavigationService: CardNavigationService,
        private _dataEventService: DataEventService) {
        super(node);
    }

    public onInit(): void {
        this._cardNavigationService.enableRowNavigation(this._node);
    }

    @ClickListener('a')
    public onViewContent(event: MouseEvent): void {
        const item: HTMLAnchorElement = event.currentTarget as HTMLAnchorElement;        
        this._dataEventService.viewContent(new URL(item.href).pathname);
    }

    public dispose(): void {
        this._cardNavigationService.disableNavigation(this._node);
        super.dispose();
    }
}